import ButtonGroup, { type ButtonGroupProps } from './ButtonGroup';

export default ButtonGroup;
export { ButtonGroup };
export type { ButtonGroupProps };
